import { useTranslation } from 'react-i18next'

import { validateDraftValue } from './draftValidationUtils'

const useDraftValidation = () => {
  const { t } = useTranslation()

  const getDraftValidationRules = () => [
    // Required rule
    {
      message: t('portCall.draftSurvey.required'),
      required: true,
    },
    {
      validator: (_, value) => {
        const { isValid, errorType } = validateDraftValue(value)

        if (!isValid) {
          return Promise.reject(
            new Error(t(`portCall.draftSurvey.${errorType}`))
          )
        }

        return Promise.resolve()
      },
    },
  ]

  return {
    getDraftValidationRules,
  }
}

export default useDraftValidation
